import { webApi } from 'src/services/api/config'
import { LoginRequest, LoginResponse } from './auth.types'

/**
 * Authenticates the user and returns the session data.
 */
export const postLogin = async (
  loginRequest: LoginRequest
): Promise<LoginResponse> => {
  return await webApi.post('api/auth/login', loginRequest)
}
